import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardAction,
  CardFooter,
} from "components/ui/card";
import { Button } from "components/ui/button";
import * as Routes from "routes";
import { useHistory } from "react-router-dom";

export const EditOverageCard = () => {
  const history = useHistory();

  return (
    <Card className="col-span-2">
      <CardHeader className="">
        <CardTitle>Increase your Overage</CardTitle>
        <CardDescription>No one likes dropping API calls.</CardDescription>
        <CardAction>
          {" "}
          <Button onClick={() => history.push(Routes.orgSubscription)}>
            Edit Overage
          </Button>
        </CardAction>
      </CardHeader>
    </Card>
  );
};
